
import { Injectable, ApplicationRef } from '@angular/core'
import { Router, ActivationStart, ActivationEnd, ActivatedRouteSnapshot } from '@angular/router'
import { LandingComponent } from '../../secure/nav/landing/landing.component'

@Injectable()
export class NavService {
  static stateHistory: string[] = []
  static canGoBack = false
  static current: ActivatedRouteSnapshot

  get canGoBack () {
    return NavService.canGoBack
  }

  set canGoBack (value: boolean) {
    NavService.canGoBack = value
    this.ref.tick()
  }

  constructor(
    private router: Router,
    private ref: ApplicationRef
  ) {
    router.events
      .filter(event => event instanceof ActivationStart || event instanceof ActivationEnd)
      .subscribe((event: ActivationStart | ActivationEnd) => {
        if (event instanceof ActivationStart) {
          this.canGoBack = false
          NavService.current = null
        } else if (event instanceof ActivationEnd && !NavService.current) {
          NavService.current = event.snapshot
          this.canGoBack = !NavService.current.component || !(NavService.current.component === LandingComponent)
        }
      })
  }

  back () {
    if (this.canGoBack) {
      if (NavService.current.data.parent) {
        this.router.navigateByUrl(NavService.current.data.parent, { replaceUrl: true })
      } else {
        history.back()
      }
    }
  }
}
